export const INFINITE_SLIDER_I18N_ENTRIES = {
  infinite_slider_Data1: {
    es: '<p><span class="i18n-bold">Detección</span> de ausencia de línea</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  infinite_slider_Data2: {
    es: '<p>Detección de <span class="i18n-bold">retrorreflectancia</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  infinite_slider_Data3: {
    es: '<p>Generación de <span class="i18n-bold">informes</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  infinite_slider_Data4: {
    es: '<p>Sin necesidad de <span class="i18n-bold">instalación</span></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  infinite_slider_Data5: {
    es: '<p><span class="i18n-bold">Comparación</span> de métricas</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  infinite_slider_Data6: {
    es: '<p><span class="i18n-bold">Georreferenciación</span> de la información</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
